import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `\u05E1\u05D3\u05E8\u05D4`,
  UNIT_PLURAL: `\u05E1\u05D3\u05E8\u05D5\u05EA`,
  UNIT_SHORT: `\u05E1\u05D3\u05E8\u05D4`,
  SUBUNIT_SINGULAR: `\u05E4\u05E8\u05E7`,
  SUBUNIT_PLURAL: `\u05E4\u05E8\u05E7\u05D9\u05DD`,
  SUBUNIT_SHORT: `\u05E4\u05E8\u05E7`,
  SUBUNIT_VERB_FUTURE: `\u05DE\u05E9\u05D5\u05D3\u05E8`,
  SUBUNIT_VERB_PAST: `\u05E9\u05D5\u05D3\u05E8`
};
const anime_bluray = {
  UNIT_SINGULAR: `\u05E1\u05D3\u05E8\u05D4`,
  UNIT_PLURAL: `\u05E1\u05D3\u05E8\u05D5\u05EA`,
  UNIT_SHORT: `\u05E1\u05D3\u05E8\u05D4`,
  SUBUNIT_SINGULAR: `\u05DB\u05E8\u05DA`,
  SUBUNIT_PLURAL: `\u05DB\u05E8\u05DB\u05D9\u05DD`,
  SUBUNIT_SHORT: `\u05DB\u05E8\u05DA`,
  SUBUNIT_VERB_FUTURE: `\u05D9\u05E6\u05D0 \u05DC\u05D0\u05D5\u05E8`,
  SUBUNIT_VERB_PAST: `\u05E4\u05D5\u05E8\u05E1\u05DD`
};
const manga_chapter = {
  UNIT_SINGULAR: `\u05DE\u05E0\u05D2\u05D4`,
  UNIT_PLURAL: `\u05DE\u05E0\u05D2\u05D5\u05EA`,
  UNIT_SHORT: `\u05DE\u05E0\u05D2\u05D4`,
  SUBUNIT_SINGULAR: `\u05E6'\u05E4\u05D8\u05E8`,
  SUBUNIT_PLURAL: `\u05E6'\u05E4\u05D8\u05E8\u05D9\u05DD`,
  SUBUNIT_SHORT: `\u05E6'\u05E4\u05D8\u05E8`,
  SUBUNIT_VERB_FUTURE: `\u05D9\u05E6\u05D0 \u05DC\u05D0\u05D5\u05E8`,
  SUBUNIT_VERB_PAST: `\u05E4\u05D5\u05E8\u05E1\u05DD`
};
const manga_volume = {
  UNIT_SINGULAR: `\u05DE\u05E0\u05D2\u05D4`,
  UNIT_PLURAL: `\u05DE\u05E0\u05D2\u05D5\u05EA`,
  UNIT_SHORT: `\u05DE\u05E0\u05D2\u05D4`,
  SUBUNIT_SINGULAR: `\u05DB\u05E8\u05DA`,
  SUBUNIT_PLURAL: `\u05DB\u05E8\u05DB\u05D9\u05DD`,
  SUBUNIT_SHORT: `\u05DB\u05E8\u05DA`,
  SUBUNIT_VERB_FUTURE: `\u05D9\u05E6\u05D0 \u05DC\u05D0\u05D5\u05E8`,
  SUBUNIT_VERB_PAST: `\u05E4\u05D5\u05E8\u05E1\u05DD`
};
const strings = {
  ALL_COMPLETE: `!\u05DB\u05DC \u05D4\u05E4\u05E8\u05D5\u05D9\u05D9\u05E7\u05D8\u05D9\u05DD \u05D4\u05D5\u05E9\u05DC\u05DE\u05D5`,
  CONNECTION_ERROR: `\u05D1\u05E2\u05D9\u05D9\u05EA \u05D7\u05D9\u05D1\u05D5\u05E8`,
  CONFIG_HEADER: `\u05EA\u05E6\u05D5\u05E8\u05D4`,
  WEBSITE_SETTINGS_HEADER: `\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05D0\u05EA\u05E8`,
  APP_URL: `\u05D4-URL \u05E9\u05DC \u05D4\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D4`,
  LINK_PAGE: `\u05DC\u05E2\u05DE\u05D5\u05D3`,
  PAGE_BGCOLOR: `\u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05D0\u05EA\u05E8 \u05E8\u05D0\u05E9\u05D9`,
  NO_COLOR: `\u05D4\u05EA\u05E2\u05DC\u05DD \u05DE\u05E6\u05D1\u05E2 \u05D4\u05E8\u05E7\u05E2`,
  RECOMMENDED_BGCOLOR: `\u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DE\u05D5\u05DE\u05DC\u05E5`,
  OVERRIDE_BGCOLOR: `\u05E2\u05E7\u05D5\u05E3 \u05D4\u05DE\u05DC\u05E6\u05D4`,
  THEME_HEADER: `\u05E2\u05E8\u05DB\u05EA \u05E0\u05D5\u05E9\u05D0`,
  THEME_LIGHT: `\u05D1\u05D4\u05D9\u05E8`,
  THEME_DARK: `\u05DB\u05D4\u05D4`,
  SIZE_HEADER: `\u05D2\u05D5\u05D3\u05DC`,
  SIZE_SMALL: `\u05E7\u05D8\u05DF (\u05DC\u05D0 \u05DE\u05D5\u05DE\u05DC\u05E5)`,
  SIZE_NORMAL: `\u05E8\u05D2\u05D9\u05DC`,
  ACCENT_HEADER: `\u05E6\u05D1\u05E2 \u05D3\u05D2\u05E9`,
  ACCENT_RED: `\u05D0\u05D3\u05D5\u05DD`,
  ACCENT_YELLOW: `\u05E6\u05D4\u05D5\u05D1`,
  ACCENT_GREEN: `\u05D9\u05E8\u05D5\u05E7`,
  ACCENT_BLUE: `\u05DB\u05D7\u05D5\u05DC`,
  ACCENT_INDIGO: `\u05D0\u05D9\u05E0\u05D3\u05D9\u05D2\u05D5`,
  ACCENT_PURPLE: `\u05E1\u05D2\u05D5\u05DC`,
  ACCENT_PINK: `\u05D5\u05E8\u05D5\u05D3`,
  ACCENT_NONE: `\u05DC\u05DC\u05D0`,
  LANGUAGE_HEADER: `\u05E9\u05E4\u05D4`,
  EMBED_HEADER: `\u05E7\u05D5\u05D3 \u05D4\u05D8\u05DE\u05E2\u05D4 \u05DC\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1`,
  EMBED_DESCRIPTION: `\u05D4\u05E7\u05D8\u05DF \u05D0\u05EA \u05D4\u05D0\u05D9\u05D9\u05E4\u05E8\u05D9\u05D9\u05DD \u05DC\u05D0\u05D7\u05E8 \u05D8\u05E2\u05D9\u05E0\u05D4`,
  EMBED_SHOW: `\u05D4\u05E6\u05D2 \u05E7\u05D5\u05D3 \u05D4\u05D8\u05DE\u05E2\u05D4`,
  EMBED_HIDE: `\u05D4\u05E1\u05EA\u05E8 \u05E7\u05D5\u05D3 \u05D4\u05D8\u05DE\u05E2\u05D4`,
  ALL_POSITIONS: `\u05DB\u05DC \u05D4\u05EA\u05E4\u05E7\u05D9\u05D3\u05D9\u05DD`,
  UNIT_JOINT_WITH: `\u05D1\u05E9\u05D9\u05EA\u05D5\u05E3 \u05E2\u05DD {0}`,
  UNIT_SHOW_LESS: `\u05D4\u05E6\u05D2 \u05E4\u05D7\u05D5\u05EA`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `\u05D4\u05E6\u05D2 {1} %SUBUNIT_SINGULAR% \u05E0\u05D5\u05E1\u05E3...`,
  UNIT_SHOW_REMAINDER_PLURAL: `\u05D4\u05E6\u05D2 {1} %SUBUNIT_PLURAL% \u05E0\u05D5\u05E1\u05E4\u05D9\u05DD...`,
  UNIT_UPDATED: `\u05E2\u05D5\u05D3\u05DB\u05DF {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} \u05D9\u05E4\u05D5\u05E8\u05E1\u05DD \u05D1\u05E7\u05E8\u05D5\u05D1`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT% {0} \u05DE\u05DE\u05EA\u05D9\u05DF \u05DC: {2}`,
  SUBUNIT_NO_PROGRESS: `(\u05D0\u05D9\u05DF \u05E2\u05D3\u05DB\u05D5\u05DF \u05E2\u05D3\u05D9\u05D9\u05DF)`
};
import he from "../../_snowpack/pkg/javascript-time-ago/locale/he.json.proxy.js";
const lang = {
  locale: he,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=he.js.map
